module.exports = __webpack_public_path__ + "assets/kcuk.f96a909b8c380a3e8ae86e0975fd0dbe.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/home/kcuk.png
 ** module id = 349
 ** module chunks = 0
 **/